import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "simple-icons:binance",
      "clip-path": "url(#clip0_2820_75439)"
    }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M13.8533 11.5995L16.1175 13.8628L9.99 19.9903L3.86333 13.8636L6.1275 11.5995L9.99083 15.4828L13.8533 11.5995ZM17.7175 7.73615L20 9.99948L17.7375 12.2628L15.4733 9.99948L17.7175 7.73615ZM9.99083 7.73615L12.2542 9.97948L9.99 12.2436L7.72667 9.99948L9.99 7.73698L9.99083 7.73615ZM2.26333 7.73615L4.50833 9.99948L2.265 12.2428L0 9.99948L2.26333 7.73615ZM9.99167 0.0078125L16.1183 6.11615L13.8542 8.37865L9.99083 4.51531L6.12833 8.39865L3.86417 6.13531L9.99083 0.00864583L9.99167 0.0078125Z",
        fill: "#F3BA2F"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2820_75439" }, [
        _createElementVNode("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }